import { InjectionToken } from '@angular/core';
import { environment } from '@data-terminal/environment';

export const TASK_FORM_ROOT_SCRIPT_URL = new InjectionToken<string>(
    'Wrapper around environment.TASK_FORM_ROOT_SCRIPT_URL',
    {
        providedIn: 'root',
        factory: () => `${environment.TASK_FORM_ROOT_SCRIPT_URL}`,
    }
);
